<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells_hd">基础信息</div>
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <!-- <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">设备编号</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.eq_code"
              placeholder="请填写"
            />
          </div>
        </div> -->
        <div class="weui-cell" slot="eq_name">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.eq_name || "设备名称"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.eq_name"
              placeholder="请输入设备名称"
            />
          </div>
        </div>
        <div class="weui-cell" slot="eq_orispeccode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.eq_orispeccode || "规格型号"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.eq_orispeccode"
              placeholder="请输入规格型号"
            />
          </div>
        </div>
        <div class="weui-cell" slot="eq_brand">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.eq_brand || "品牌"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.eq_brand"
              placeholder="请输入品牌"
            />
          </div>
        </div>
        <combo-search-box slot="eq_kind"
          :label="customLabel.eq_kind || '设备类别'"
          placeholder="请选择或输入设备类别"
          v-model="form.main.eq_kind"
          url="/api/oa/equipmentKind/getCombo"
          ref="combo1"
        />
        <div class="weui-cell weui-cell_select weui-cell_select-after" slot="eq_check_time">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.eq_check_time || "检查周期"}}</label>
          </div>
          <div class="weui-cell__bd flex">
            <input
              class="weui-input time"
              type="text"
              v-model="form.main.eq_check_time"
              placeholder="请填写"
            />
            <select
              class="weui-select unit"
              v-model="form.main.eq_check_period"
              placeholder="请选择"
            >
              <option :value="'year'">年</option>
              <option :value="'month'">月</option>
              <option :value="'week'">周</option>
              <option :value="'day'">日</option>
            </select>
          </div>
        </div>
        <div class="weui-cell weui-cell_select weui-cell_select-after" slot="eq_state">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.eq_state || "设备状态"}}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.eq_state"
              placeholder="请选择"
            >
              <option>正常使用</option>
              <option>维修</option>
              <option>保养</option>
              <option>报废</option>
            </select>
          </div>
        </div>
        <file-field v-model="form.main.eq_attach" slot="eq_attach"/>
      </custom-layout>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="'1-' + xindex"
      >
        <div class="weui-cells__title">
          <span>检查信息{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem1(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-cell" slot="ed_project">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.ed_project || "检查项目"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.ed_project"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" slot="ed_method">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.ed_method || "检查方法"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.ed_method"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" slot="ed_standard">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.ed_standard || "检查标准"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.ed_standard"
                placeholder="请填写"
              />
            </div>
          </div>
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem1"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import ComboSearchBox from "@/components/field/ComboSearchBox.vue";
import FileField from "@/components/field/FileField.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    ComboSearchBox,
    FileField,
  },
  data() {
    return {
      baseUrl: "/api/oa/equipment",
      codeField: "eq_code",
      statusField: "eq_audit_status",
      caller: "Equipment",
      xtype: "oa-equipment-formpanel",
      form: {
        main: {
          eq_check_time: 1,
          eq_check_period: "year",
        },
        items: [
          {
            ed_project: null,
            ed_method: null,
            ed_standard: null,
          },
        ],
      },
    };
  },
  mounted() {
    //var me = this;
    // if (!me.$route.query.id) {
    //   me.$loading({
    //     url: "/api/commons/number/getMaxnumber",
    //     method: "POST",
    //     params: {
    //       caller: "Equipment",
    //     },
    //   }).then(function (res) {
    //     if (res.success) {
    //       me.form.main.eq_code = res.data;
    //     }
    //   });
    // }
  },
  methods: {
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items;
      if (!main.eq_name) {
        me.$weui.topTips("请填写设备名称", 2000);
      } else if (!main.eq_kind) {
        me.$weui.topTips("请选择设备类别", 2000);
      } else if (!main.eq_check_time) {
        me.$weui.topTips("请填写检查周期", 2000);
      } else if (!main.eq_state) {
        me.$weui.topTips("请选择设备状态", 2000);
      } else {
        var count1 = 0;
        items.forEach(function (item) {
          if (!item.ed_project) {
            me.$weui.topTips(`第${count1 + 1}行未填写检查项目`, 2000);
            return false;
          } else if (!item.ed_method) {
            me.$weui.topTips(`第${count1 + 1}行未填写检查方法`, 2000);
            return false;
          } else if (!item.ed_standard) {
            me.$weui.topTips(`第${count1 + 1}行未填写检查标准`, 2000);
            return false;
          } else {
            count1++;
            item.ed_detno = count1;
          }
        });

        if (count1 == items.length) {
          main.eq_kind && me.kind_combo_save(main.eq_kind);
          me.p_save();
        }
      }
    },
    kind_combo_save(eq_kind) {
      var me = this;
      let combo1 = me.$refs.combo1.data,
        save = combo1.some((item) => {
          return item.value == eq_kind;
        });
      if (!save) {
        me.$ajax({
          url: "/api/oa/equipmentKind/save",
          method: "POST",
          jsonData: {
            ek_name: eq_kind,
            id: 0,
          },
        }).then();
      }
    },
    /**
     * 删除行
     */
    removeItem1(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem1() {
      var me = this,
        items = me.form.items;
      items.push({
        ed_project: null,
        ed_method: null,
        ed_standard: null,
      });
    },
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
}
.time {
  flex: 1;
}
.unit {
  width: 50px;
}
</style>